import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { getService, postService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';
import moment from 'moment';
import { SubmitHandler, useForm } from 'react-hook-form';
import { eventDetails } from '../../../api/Dtos/profileDto';
import { useLoader } from '../../../Loader/LoaderContext';
import { mtCountryDto } from '../../../api/interfaces/addUser';
import { useToaster } from '../../../Toaster/Toaster';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DynamicTextPopup from '../Modals/dynamicTextPopup';
function EditEvent() {
  const location = useLocation();
              const path = location.pathname;
  const [formData, setFormData] = useState<eventDetails>();
      const [showConfirmation, setShowConfirmation] = useState(false);
      const [searchParams] = useSearchParams();
              const leadId = searchParams.get("leadId");
              const names =searchParams.get('name');
    const navigate = useNavigate();
    const [selectedContry, setSelectedContry] = useState<string>("");
    const [selectedFiles, setSelectedFiles] = useState<string[]>([]);
    const [files, setFiles] = useState<(File | null)[]>([]);
     const today = new Date().toISOString().split("T")[0];
     const [events, setEvents] = useState<any[]>([]);
     const [selectedFile, setSelectedFile] = useState<File | null>(null);
      const [file, setFile] = useState<string | null>(null);
       const { showToast } = useToaster();
         const [submittedData, setSubmittedData] = useState<any | null>(null);
        const [mtContryData, setMtCountry] = useState<mtCountryDto[]>([]);
        const [selectedCountry, setSelectedCountry] = useState("");
        const [phoneCode, setPhonecode] = useState({ isoCode: "", code: "" });
        const [expanded, setExpanded] = useState<string | false>(false);
        const handleFileChanges = (
          event: React.ChangeEvent<HTMLInputElement>,
          index: number
        ) => {
          const file = event.target.files?.[0];
          const allowedTypes = ["image/png", "image/jpeg"];
          const maxSizeInMB = 3;
      
          if (file) {
            // Validate file type
            if (!allowedTypes.includes(file.type)) {
              alert("Please select a valid image (PNG or JPG).");
              return;
            }
      
            // Validate file size
            if (file.size > maxSizeInMB * 1024 * 1024) {
              alert(`File size should not exceed ${maxSizeInMB} MB.`);
              return;
            }
      
            // Create a file URL
            const fileUrl = URL.createObjectURL(file);
      
            // Update the file array
            setFiles((prevFiles) => {
              const updatedFiles = [...prevFiles];
              updatedFiles[index] = file; // Assign the file at the given index
              return updatedFiles;
            });
      
            // Update the preview URL array
            setSelectedFiles((prevUrls) => {
              const updatedUrls = [...prevUrls];
              updatedUrls[index] = fileUrl; // Assign the URL at the given index
              return updatedUrls;
            });
          }
        };
        const handleDateClick = (e: React.MouseEvent<HTMLInputElement>) => {
          e.preventDefault(); // Prevent default click action if needed
          e.currentTarget.showPicker(); // Re-focus to trigger the date picker again
        };
        const handleChange =
      (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
      };
        const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.target.files && e.target.files[0]) {
            const selectedFile = e.target.files[0];
            setSelectedFile(selectedFile);
            // setValue('imageDto',selectedFile)
            // Convert the file to a Base64 string
            const preview = await convertToBase64(selectedFile);
            setFile(preview);
          }
        };
        const convertToBase64 = (file: File): Promise<string> => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
          });
        };
        const handleCountryChanges = (e: React.ChangeEvent<HTMLSelectElement>,index:number) => {
          const selectedCountryId = e.target.value;
          setSelectedCountry(selectedCountryId);
      
          const selectedCountry = mtContryData.find(
            (country: any) => country.id == selectedCountryId
          );
          if (selectedCountry) {
            setValue(`eventReqDtos.${index}.phoneisoCode`, selectedCountry.isoCode);
          }
        };
        const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
          
          const selectedCountryId = e.target.value;
          setSelectedCountry(selectedCountryId);
      
          const selectedCountry = mtContryData.find(
            (country: any) => country.id == selectedCountryId
          );
          if (selectedCountry) {
            setPhonecode((prev) => {
              const updatedPhoneCode = {
                isoCode: selectedCountry.isoCode,
                code: selectedCountry.code,
              };
              return updatedPhoneCode;
            });
            console.log(phoneCode);
            setValue(`phoneisoCode`, selectedCountry.isoCode);
          }
        };
        const mtCountryDtoData = async () => {
            setLoading(true);
            try {
              const response = await getService(API_ENDPOINTS.countryData);
              console.log(response);
              setMtCountry(response.data);
              return response.data
            } catch (error) {
              console.error("Error fetching vehicle data:", error);
            } finally {
              setTimeout(() => {
                setLoading(false);
              }, 500);
            }
          };
          const handleAddEvent = () => {
            const newEventId = events?.length + 1;
            setEvents([
              ...events,
              {
                id: newEventId,
                name: `Event ${newEventId}`,
                startDate: "",
                endDate: "",
                contactPersonName: "",
                contactPersonEmail: "",
                phoneNo: "",
                mtCountryDto: {
                  id: null,
                  name: "",
                  code: "",
                  isoCode: "",
                }, // Default mtCountryDto object
                venue: "",
                link: "",
                type: "",
                imageDto: {
                  name: "",
                  base64Str: "",
                  type: "",
                  documentUrl: "",
                },
              },
            ]);
            setExpanded(`panel${newEventId}`);
          };
           const {
                register,
                handleSubmit,
                setValue,
                reset,
                watch,
                getValues, trigger,
                formState: { errors ,isDirty},
              } = useForm<eventDetails>({
                mode: "onChange", // This allows validation checks to trigger as the user types.
              });
               const { setLoading } = useLoader();
                    useEffect(()=>{
                      mtCountryDtoData();
                      fetchDetails();
                    },[]);
                   
                     const fetchDetails = async () => {
                          try {
                            let url:string;
                            const countryData = await mtCountryDtoData();
                            const response = await getService(API_ENDPOINTS.getEventOrganizer+"?leadId="+leadId); // Fetch post details using 'id'
                            setSubmittedData(response.data);
                      const res =response.data;
                      setSelectedCountry(response.data?.mtCountryDto?.id);
                      const formattedEvents = response.data?.eventReqDtos?.map((event: any) => ({
                                             ...event,
                                             name:event?.name,
                                             eventDetails:event?.eventDetails,
                                             contactPersonName:event?.contactPersonName,
                                             contactPersonEmail:event?.contactPersonEmail,
                                             phoneNo:event?.phoneNo,
                                             type:event?.type,
                                             mtCountryDto:event?.mtCountryDto?.id,
                                             venue:event?.venue,
                                             link:event?.link,
                                             startDate: event.startDate ? moment(event.startDate, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
                                             endDate: event.endDate ? moment(event.endDate, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
                                             imageDto: event?.imageDto || null, // Include imageDto
                                           })) || [];
                                           setEvents(formattedEvents)
                                           if (Array.isArray(countryData)) {
                                            
                                            const selectedIsoCode = response.data?.mtCountryDto?.id;
                                            const selectedCountry = countryData.find(
                                               (country: any) => country.id === selectedIsoCode
                                             );
                                             if (selectedCountry) {
                                               setPhonecode({
                                                 isoCode: selectedCountry.isoCode,
                                                 code: selectedCountry.code,
                                               });
                                               setValue("phoneisoCode", selectedIsoCode);}else{
                                                const selectedCountry = countryData.find(
                                                  (country: any) => country.id == "1"
                                                );
                                                setPhonecode({
                                                  isoCode: selectedCountry.isoCode,
                                                  code: selectedCountry.code,
                                                });
                                                setValue("phoneisoCode", selectedIsoCode);
                                               }
                                               formattedEvents.forEach((event: any, index: number) => {
                                                const selectedCountry = countryData.find((country: any) => country.id === event.mtCountryDto);
                                                if (selectedCountry) {
                                                  console.log(`Setting phoneisoCode for event at index ${index}:`, selectedCountry.isoCode);
                                                  setValue(`eventReqDtos.${index}.phoneisoCode`, selectedCountry.isoCode);
                                                } else{
                                                  const selectedCountry = countryData.find(
                                                    (country: any) => country.id == '1'
                                                  );
                                                  setPhonecode({
                                                    isoCode: selectedCountry.isoCode,
                                                    code: selectedCountry.code,
                                                  });
                                                  // setValue("phoneisoCode", selectedIsoCode);
                                                }
                                              });
                                              
                                          }
                      if(!response.data?.eventReqDtos?.length){
                        const newEventId = events.length + 1;
                        setEvents([
                          ...events,
                          {
                            id: newEventId,
                            name: `Event ${newEventId}`,
                            startDate: "",
                            endDate: "",
                            contactPersonName: "",
                            contactPersonEmail: "",
                            phoneNo: "",
                            mtCountryDto: {
                              id: null,
                              name: "",
                              code: "",
                              isoCode: "",
                            }, // Default mtCountryDto object
                            venue: "",
                            link: "",
                            type: "",
                            imageDto: {
                              name: "",
                              base64Str: "",
                              type: "",
                              documentUrl: "",
                            },
                          },
                        ]);
                      }
                     
                      reset({
                        ...response.data, // Resetting other data from the response
                        eventReqDtos: formattedEvents,
                      })
                            setTimeout(() => {
                              setLoading(false); // Stop loader after 500ms
                            //   setIsLoading(false); // Stop local loading
                            }, 500);
                          } catch (error) {
                            console.error("Error fetching post details:", error);
                            setTimeout(() => {
                              setLoading(false); // Stop loader in case of error
                            //   setIsLoading(false);
                            }, 500);
                          }
                        };
                       
                        const phoneNuberChanges = (e: React.ChangeEvent<HTMLSelectElement>,index:number) => {
      
                          const selectedIsoCode = e.target.value;
                         const selectedCountry = mtContryData.find(
                            (country: any) => country.isoCode === selectedIsoCode
                          );
                      
                          if (selectedCountry) {
                            setValue(`eventReqDtos.${index}.phoneisoCode`, selectedCountry.isoCode);
                            setPhonecode({
                              isoCode: selectedCountry.isoCode,
                              code: selectedCountry.code,
                            });
                          }
                        };
                        
          const phoneNuberChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
            const selectedIsoCode = e.target.value;
            console.log("Selected ISO Code:", selectedIsoCode);
        
            const selectedCountry = mtContryData.find(
              (country: any) => country.isoCode === selectedIsoCode
            );
        
            if (selectedCountry) {
              setPhonecode({
                isoCode: selectedCountry.isoCode,
                code: selectedCountry.code,
              });
              console.log("Updated Phone Code:", {
                isoCode: selectedCountry.isoCode,
                code: selectedCountry.code,
              });
            //   setValue("phoneNo", "");
            }
          };
          const convertFileToBase64 = (file: File): Promise<string> => {
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = () => resolve(reader.result as string);
              reader.onerror = (error) => reject(error);
            });
          };
             const onFormSubmit:SubmitHandler<eventDetails> = async (data) => {
                            console.log(data);
                            setFormData(data);
                            setShowConfirmation(true)
                            
                            
                          }
    
    const users = () => {
      if(path ==='/portals/leads/viewUser/editEvent'){
        navigate("/portals/leads/viewUser")
      }else if( path =='/portals/vendors/activeVendor/editEvent' ){
        navigate('/portals/vendors/activeVendor')
      }else if(path =='/portals/vendors/inActiveVendor/editEvent'){
        navigate('/portals/vendors/inActiveVendor')
      }else if( path === "/portals/bookings/viewBooking/editEvent" && names =='booked'){
        navigate('/portals/bookings/viewBooking')
      }else if( path === "/portals/bookings/viewBooking/editEvent" && names =='confirmed'){
        navigate('/portals/bookings/confirmedBooking')
      }
      else if( path === "/portals/bookings/confirmedBooking/editEvent" && names =='confirmed'){
        navigate('/portals/bookings/confirmedBooking')
      }
      else{
        navigate('/portals/proposals/viewProposal')
      }
  };
    const handleClosePopup = () => setShowConfirmation(false);
                        const saveData =async ()=>{
                          setLoading(true);
                          const updatedLeaderShipTeamDtos = await Promise.all(
                                  (formData?.eventReqDtos ?? [])?.map(async (team, index) => {
                                    const formattedStartDate = team?.startDate
                                    ? moment(team.startDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                                    : "";
                                  const formattedEndDate = team?.endDate
                                    ? moment(team.endDate, "YYYY-MM-DD").format("DD/MM/YYYY")
                                    : "";
                                    const mtCountryDto = team?.mtCountryDto
                              ? { id: parseInt(team.mtCountryDto as unknown as string, 10) }
                              : null;
                                    if (files[index]) {
                                      const base64Str = await convertFileToBase64(files[index] as File);
                                      const name = (files[index] as File).name;
                                      const type = (files[index] as File).type;
                            
                                      return {
                                        ...team,
                                        startDate: formattedStartDate,
                                        endDate: formattedEndDate,
                                        mtCountryDto:mtCountryDto,
                                        imageDto: {
                                          base64Str: base64Str,
                                          name,
                                          type,
                                        },
                                      };
                                    }
                                    return {
                                      ...team,
                                      startDate: formattedStartDate,
                                      endDate: formattedEndDate,
                                      mtCountryDto: mtCountryDto,
                                    };
                                  })
                                );
                          try {
                              let payload={
                                ...submittedData,
                                leadId:leadId,
                                name:formData?.name,
                                  email:formData?.email,
                                  phoneNo:formData?.phoneNo ,
                                  contactPersonName:formData?.contactPersonName,
                                  companyInfo:formData?.companyInfo,
                                  imageDto: selectedFile
                                  ? {
                                      name: selectedFile?.name,
                                      type: selectedFile?.type,
                                      base64Str: file,
                                    }
                                  : formData?.imageDto?.documentUrl
                                  ? { ...formData.imageDto } // If existing image, retain it
                                  : null,
                                  streetAddress:formData?.streetAddress,
                                  apartment:formData?.apartment,
                                  state:formData?.state,
                                  postalCode:formData?.postalCode,
                                   mtCountryDto: formData?.mtCountryDto ? {
                                                id: parseInt(formData?.mtCountryDto as unknown as string, 10),
                                              } : null,
                                              city:formData?.city,
                                            eventReqDtos : updatedLeaderShipTeamDtos
                                            
                              }
                                const response = await postService(API_ENDPOINTS.saveEventOrganizer,payload);
                                if(response){
                                  setSelectedCountry("");
                                  handleClosePopup();
                                  if(path ==='/portals/leads/viewUser/editEvent'){
                                    navigate('/portals/leads/viewUser/eventPreview?leadId='+leadId)
                                  } else if(path ==='/portals/bookings/viewBooking/editEvent'){
                                    navigate('/portals/bookings/viewBooking/eventPreview?leadId='+leadId+"&name=booked")
                                  }
                                  else if( path === "/portals/bookings/confirmedBooking/editEvent"){
                                    navigate('/portals/bookings/confirmedBooking/eventPreview?leadId='+leadId+"&name=confirmed")
                                  }
                                  else{
                                    navigate('/portals/proposals/viewProposal/eventPreview?leadId='+leadId)
                                  }
                                    showToast('Profile updated successfully!', 'success',"");
                                 
                                }
                          } catch (error: any) {
                              // setApiError(error.response?.data?.message);
                              console.error('Login error:', error);
                              if(error.response?.data?.message === 'Invalid Otp. Please try again.'){
                                
                              }
                          }
                          finally {
                              setLoading(false);
                          }
                          
                        }
                        const viewLeadUser =()=>{
                          if(path ==='/portals/leads/viewUser/editEvent'){
                            navigate('/portals/leads/viewUser/eventPreview?leadId='+leadId)
                          }else if( path =='/portals/vendors/activeVendor/editEvent' ){
                            navigate('/portals/vendors/activeVendor/eventPreview?leadId='+leadId)
                          }else if(path =='/portals/vendors/inActiveVendor/editEvent'){
                            navigate('/portals/vendors/inActiveVendor/eventPreview?leadId='+leadId)
                          }else if( path === "/portals/bookings/viewBooking/editEvent" && names =='booked'){
                            navigate('/portals/bookings/viewBooking/eventPreview?leadId='+leadId+"&name=booked")
                          }else if( path === "/portals/bookings/viewBooking/editEvent" && names =='confirmed'){
                            navigate('/portals/bookings/viewBooking/eventPreview?leadId='+leadId+"&name=confirmed")
                          }
                          else if( path === "/portals/bookings/confirmedBooking/editEvent" && names =='confirmed'){
                            navigate('/portals/bookings/confirmedBooking/eventPreview?leadId='+leadId+"&name=confirmed")
                          }
                          else{
                            navigate('/portals/proposals/viewProposal/eventPreview?leadId='+leadId)
                          }
                         
                        }
  return (
    <div className="h-full py-2 w-full">
    <div className="flex items-center cursor-pointer mb-4">
        <h2
            className="mr-2 text-gray-700 font-semibold text-sm"
            onClick={users}
        >
          {path === "/portals/proposals/viewProposal/editEvent" ? 'Proposal' : (path =='/portals/vendors/inActiveVendor/editEvent' || path =='/portals/vendors/activeVendor/editEvent') ? 'Vendors' :
           path =='/portals/bookings/viewBooking/editEvent' && names ==='booked' ? ' Booked' : (path =='/portals/bookings/viewBooking/editEvent' && names ==='confirmed' || path =='/portals/bookings/confirmedBooking/editEvent') ? ' Booked' :
          'Leads'}
        </h2>{" "}

        <img src="/images/arrowIcons.svg" className="mr-2" />{" "}
        <span className="text-gray-400 font-semibold text-sm">
        {path === "/portals/proposals/viewProposal/editEvent" ? 'View Proposal' : (path =='/portals/vendors/inActiveVendor/editEvent' || path =='/portals/vendors/activeVendor/editEvent') ? 'View Vendors' :
        path =='/portals/bookings/viewBooking/editEvent' && names ==='booked' ? 'View Booked' : (path =='/portals/bookings/viewBooking/editEvent' && names ==='confirmed' || path =='/portals/bookings/confirmedBooking/editEvent') ? 'View Confirmed' :
        'View Leads'}
        </span>
    </div>
    <div className='flex justify-between w-full'>
            <div className='flex items-center mb-2'>
                <img src='/images/back.svg' className='mr-2 cursor-pointer' onClick={viewLeadUser} />
                <h1 className="text-2xl font-bold text-[#2D2E2F] mr-3">{path === "/portals/proposals/viewProposal/editEvent" ? 'Edit Proposal Details' : (path =='/portals/vendors/inActiveVendor/editEvent' || path =='/portals/vendors/activeVendor/editEvent') ? 'Edit Vendors Details' :
                path =='/portals/bookings/viewBooking/editEvent' && names ==='booked' ? 'Edit Booked Details' : (path =='/portals/bookings/viewBooking/editEvent' && names ==='confirmed') || path =='/portals/bookings/confirmedBooking/editEvent' ? 'Edit Booked Details' :
                'Edit Lead Details'} </h1>
            </div>
           
        </div>
      
    <form onSubmit={handleSubmit(onFormSubmit)}>
    <div className='bg-white px-8 pt-8 pb-2'>
        <div className='w-[80%]'>
    <p className='font-bold text-2xl text-primary-color border-b pb-4 border-b-gray-200 '>Add basic information</p>
    <div className='flex items-center py-3 my-3'>
<img src={
                  file
                    ? (file as string)
                    : selectedFile
                    ? URL.createObjectURL(selectedFile)
                    : submittedData?.imageDto?.documentUrl || '/images/userImg.svg'
                }
                alt="Preview" className='w-[80px] h-[80px] mr-3 rounded-full'  />
<div>
      <p className="font-semibold text-gray-900 text-base font-sans mb-0">
      Upload Event Photo
      </p>
      <p className="text-sm font-normal text-gray-500 mt-1 font-sans mb-3">
        Photo should be atleast in 150px X 150px
      </p>
      <label className=' mt-2 px-4 border border-[#D1D5DB] text-[#374151] font-medium text-sm rounded-md p-2 cursor-pointer'>
    Upload new photo
    <input
      type="file" 
      accept="image/*"
      onChange={handleFileChange}
      className="hidden"
    />
  </label>
    </div>
</div>
    <div className="grid grid-cols-1 gap-4">

        <div className="form-group">
            <label
                htmlFor="username"
                className="block text-[#374151] font-semibold text-sm font-sans"
            >
                Event Name
            </label>
            <div className="input-group mt-2">
                <input
                    {...register("name", {
                      required: 'Name is required',
                    })}
                    type="text"
                    placeholder="Enter Company Name"

                    className="form-control font-normal font-Inter text-base text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                />
                {/* {errors.firstName && (
              <p className="text-red-500 text-sm mt-1">{errors.firstName.message}</p>
            )} */}
            </div>
        </div>
       
        <div className="form-group">
            <label
                htmlFor="username"
                className="block text-[#374151] font-semibold text-sm font-sans"
            >
               Contact Person Name
            </label>
            <div className="input-group mb-2 mt-2">
                <input
                    {...register("contactPersonName", {
                      // required: 'firstName is required',
                    })}
                    type="text"
                    placeholder="Enter Contact Person Name"

                    className="form-control font-normal font-Inter text-base text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                />
                {/* {errors.firstName && (
              <p className="text-red-500 text-sm mt-1">{errors.firstName.message}</p>
            )} */}
            </div>
        </div>

    </div>
    <div className="grid grid-cols-2 gap-7 mb-2 mt-2">

        <div className="form-group">
            <label
                htmlFor="username"
                className="block text-[#374151] font-semibold text-sm font-sans"
            >
                Email
            </label>
            <div className="input-group mb-3 mt-2">
                <input
                    {...register("email", {
                      // required: 'firstName is required',
                    })}
                    type="email"
                    placeholder="Enter your Email"
                    disabled
                    className="form-control font-normal font-Inter text-base text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                />
                {/* {errors.firstName && (
              <p className="text-red-500 text-sm mt-1">{errors.firstName.message}</p>
            )} */}
            </div>
        </div>
        <div className="form-group">
        <label
          htmlFor="username"
          className="block text-[#374151] font-semibold text-sm font-sans"
        >
          Phone Number
        </label>
        <div className=" form-group mb-4 sm:mb-0">
          <div className="flex border border-gray-300 rounded mt-1 form-controls">
            <select
              value={phoneCode.isoCode || ""}
              {...register("phoneisoCode")}
              onChange={(e) => phoneNuberChange(e)}
              className="border-none bg-white pl-3 py-2 text-sm font-semibold text-gray-700 focus:outline-none"
            >
              {mtContryData.map((item: any) => (
                <option key={item.id} value={item.isoCode || ""}>
                  {item.isoCode}
                </option>
              ))}
            </select>
            <input
              type="text"
              placeholder="Enter your phone number"
              {...register("phoneNo")}
              onInput={(e) => {
                e.currentTarget.value = e.currentTarget.value.replace(/[^0-9]/g, "");
              }}
              className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
            />
          </div>

          {/* {errors.phoneNo && (
            <p className="text-red-500 text-sm mt-1">
              {errors.phoneNo.message}
            </p>
          )} */}
        </div>
      </div>

    </div>
    <div className="grid grid-cols-1 gap-4 mt-2">

        <div className="form-group">
            <label
                htmlFor="username"
                className="block text-[#374151] font-semibold text-sm font-sans"
            >
                Event Info
            </label>
            <div className="input-group mb-3 mt-2">
                <textarea
                 rows={4}
                    placeholder="Enter Event Info"
                    {...register("companyInfo",{
                      maxLength: {
                        value: 1500,
                        message: "Event information cannot exceed 1500 characters. Please shorten your text.",
                      },
                     
                    })}
                    className="w-full border font-normal font-Inter text-base text-[#6B7280] p-2 rounded-md"
                />
                {errors.companyInfo && (
              <p className="text-red-500 text-sm mt-1">{errors.companyInfo.message}</p>
            )}
            </div>
        </div>


    </div>
  
    <div className='mt-6 mb-8'>
        <h2 className='text-gray-900 font-bold text-[20px]'>Address</h2>
        <div className="grid grid-cols-1 gap-4 mt-2">

            <div className="form-group">
                <label
                    htmlFor="username"
                    className="block text-[#374151] font-semibold text-sm font-Inter"
                >
                    Street Address
                </label>
                <div className="input-group mb-3 mt-2">
                    <input
                        {...register("streetAddress")}
                        type="text"
                        placeholder="eg. Street 7"

                        className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                    />
                    {/* {errors.firstName && (
              <p className="text-red-500 text-sm mt-1">{errors.firstName.message}</p>
            )} */}
                </div>
            </div>


        </div>
        <div className="grid grid-cols-1 gap-4 mt-2">

            <div className="form-group">
                <label
                    htmlFor="username"
                    className="block text-[#374151] font-semibold text-sm"
                >
                    Location
                </label>
                <div className="input-group mb-3 mt-2">
                    <input
                        {...register("apartment")}
                        type="text"
                        placeholder="Enter Location"

                        className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                    />
                    {/* {errors.firstName && (
              <p className="text-red-500 text-sm mt-1">{errors.firstName.message}</p>
            )} */}
                </div>
            </div>


        </div>
        <div className="grid grid-cols-2 gap-5">

        <div className="form-group">
        <label
          htmlFor="username"
          className="block text-[#374151] font-semibold text-sm"
        >
          Country
        </label>
        <div className="input-group mb-3 mt-2">
        <select
            value={selectedCountry || ""}
            {...register("mtCountryDto")}
            onChange={(e) => handleCountryChange(e)}
            className={`border p-2 rounded-md mt-1 w-full`}
          >
            <option value="">Select country</option>
            {mtContryData.map((item: any) => (
              <option
                key={item.id}
                value={item.id !== null ? item.id : ""}
              >
                {item.name}
              </option>
            ))}
          </select>
          {/* {errors.firstName && (
            <p className="text-red-500 text-sm mt-1">{errors.firstName.message}</p>
          )} */}
        </div>
      </div>
            <div className="form-group">
        <label
          htmlFor="username"
          className="block text-[#374151] font-semibold text-sm"
        >
          State
        </label>
        <div className="input-group mb-3 mt-2">
        <input
            {...register("state", {
              // required: 'Apartment is required',
            })}
            type="text"
            placeholder="Enter state Name"
            
            className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
          />
        </div>
      </div>

        </div>
        <div className="grid grid-cols-2 gap-5">

            <div className="form-group">
                <label
                    htmlFor="username"
                    className="block text-[#374151] font-semibold text-sm"
                >
                    City
                </label>
                <div className="input-group mb-3 mt-2">
                    <input
                        {...register("city")}
                        type="text"
                        placeholder="Enter City Name"

                        className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                    />
                   
                </div>
            </div>
            <div className="form-group">
                <label
                    htmlFor="username"
                    className="block text-[#374151] font-semibold text-sm"
                >
                    Postal Code
                </label>
                <div className="input-group mb-3 mt-2">
                    <input
                        {...register("postalCode")}
                        type="text"
                        placeholder="Enter Postal Code"

                        className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                    />
                    
                </div>
            </div>

        </div>
    </div></div>
    </div>
    <div className='w-full bg-white p-8 mt-8'>
  <p className='font-bold text-2xl text-primary-color border-b pb-4 border-b-gray-200'>Events</p>
    <div className="form-group mb-10 mt-5 w-[80%]">
    {events.map((event: any, index: number) => {
  const eventType = watch(`eventReqDtos.${index}.type`); // Watching event type

  return ( 
                        <div className="mt-4">
                          {/* <> */}
  
                          <div className="mb-3 bg-white" key={event.id}>
                            <Accordion
                              key={event?.id}
                              expanded={expanded === `panel${event?.id}`}
                              onChange={handleChange(`panel${event?.id}`)}
                              className="accordion-root p-3"
                              style={{
                                boxShadow: "0px 4px 32px 0px #0000001A",
                              }}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${event?.id}-content`}
                                id={`panel${event?.id}-header`}
                                className="accordion-summary text-lg font-semibold"
                                style={{ backgroundColor: "white" }}
                              >
                                <Typography
                                  className="text-lg font-semibold"
                                  style={{ fontWeight: "600", fontSize: "18px" }}
                                >
                                  Event  {index+1}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails className="accordion-details bg-white">
                                <Typography component={"div"}>
                                  {/* Form details go here */}
                                  <div className='flex items-center py-3'>
                        <img src={
                          files[index] &&
                            files[index] instanceof Blob
                            ? URL.createObjectURL(
                              files[index] as Blob
                            ) // Type assertion here
                            : submittedData?.eventReqDtos?.[index]?.imageDto?.documentUrl || '/images/userImg.svg'
                        }
                          alt="Preview" className='w-[80px] h-[80px] mr-3 rounded-full' />
                        <div>
                          <p className="font-semibold text-gray-900 text-base font-sans">
                            Upload profile
                          </p>
                          <p className="text-sm font-normal text-gray-500 mt-2 font-sans mb-3">
                            Photo should be atleast in 150px X 150px
                          </p>

                          <label className=' mt-2 px-4 border border-[#D1D5DB] text-[#374151] font-medium text-sm rounded-md p-2 cursor-pointer'>
                            Upload new photo
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                handleFileChanges(e, index)
                              }
                              className="hidden"
                            />
                          </label>
                        </div>
                      </div>
                                  <div className="form-group mb-4 ">
                                     <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                    Event Name
                                      {/* <span className="font-[400]"> (Required)</span> */}
                                    </label>
                                    <div className="relative">
                                      <input
                                        type="text"
                                        placeholder="Enter Event Name "
                                        {...register(
                                          `eventReqDtos.${index}.name`
                                        )}
                                        className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                          errors?.eventReqDtos?.[index]?.name
                                            ? "border border-[#B91C1C]"
                                            : "border border-gray-300"
                                        }`}
                                        style={{
                                          outline: errors?.eventReqDtos?.[index]
                                            ?.name
                                            ? "2px solid red"
                                            : "none",
                                        }}
                                      />
                                     
                                    </div>
                                  </div>
                                  <div className="form-group mb-4 ">
                                    <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                    Event Details
                                    </label>
                                    <div className="relative">
                                    <textarea
                                     rows={6}
                      placeholder="Enter Event Details"
                      {...register(
                        `eventReqDtos.${index}.eventDetails`,{maxLength: {
                          value: 1500,
                          message: "Event details cannot exceed 1500 characters",
                        },}
                      )}
                      className="w-full border p-2 rounded-md"
                    />
                    {errors?.eventReqDtos?.[index]?.eventDetails && (
                                      <p className="text-primary-color text-sm">
                                        {errors?.eventReqDtos[index]?.eventDetails?.message}
                                      </p>
                                    )}
                                    </div>
                                  </div>
                                  <div className="grid grid-cols-2 gap-4">
                                    <div className=" form-group mb-4 ">
                                    <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                    Start Date
                                      {/* <span className="font-[400]"> (Required)</span> */}
                                    </label>
                                    <div className="relative">
                                      <input
                                        type="date"
                                        onClick={handleDateClick}
                                        placeholder="Enter start date "
                                        min={today}
                                        {...register(
                                          `eventReqDtos.${index}.startDate`
                                        )}
                                        className={`form-control mt-1 p-2 rounded w-full font-medium`}
                                        style={{
                                          outline: errors?.eventReqDtos?.[index]
                                            ?.name
                                            ? "2px solid red"
                                            : "none",
                                        }}
                                      />
                                     
                                    </div>
                                    </div>
  
                                    <div className="form-group mb-4 ">
                                    <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                    End Date
                                    </label>
                                    <div className="relative">
                                      <input
                                        type="date"
                                        min={watch(
                                          `eventReqDtos.${index}.startDate`
                                        )}
                                        onClick={handleDateClick}
                                        placeholder="Enter end date "
                                        {...register(
                                          `eventReqDtos.${index}.endDate`
                                        )}
                                        className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                          errors?.eventReqDtos?.[index]?.name
                                            ? "border border-[#B91C1C]"
                                            : "border border-gray-300"
                                        }`}
                                        style={{
                                          outline: errors?.eventReqDtos?.[index]
                                            ?.name
                                            ? "2px solid red"
                                            : "none",
                                        }}
                                      />
                                    
                                    </div>
                                    </div>
                                  </div>
                                
                               
                                  <div className="grid grid-cols-2 gap-7 mb-2 mt-2">
                                  <div className="form-group mb-4 ">
                                    <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                    Contact Person Name
                                    </label>
                                    <div className="relative">
                                    <input
                                        type="text"
                                        placeholder="Enter Contact Person Name "
                                        {...register(
                                          `eventReqDtos.${index}.contactPersonName`
                                        )}
                                        className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                          errors?.eventReqDtos?.[index]?.name
                                            ? "border border-[#B91C1C]"
                                            : "border border-gray-300"
                                        }`}
                                        style={{
                                          outline: errors?.eventReqDtos?.[index]
                                            ?.name
                                            ? "2px solid red"
                                            : "none",
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group mb-4 ">
                                    <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                    Event Link
                                    </label>
                                    <div className="relative">
                                    <input
                                        type="text"
                                        placeholder="Enter event link "
                                        {...register(
                                          `eventReqDtos.${index}.link`,{
                                            pattern: {
                                              value: /^(https?:\/\/)(localhost|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))(:\d+)?(\/[^\s]*)?$/,
                                              message: "Enter a valid URL",
                                            },
                                          }
                                        )}
                                        className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                          errors?.eventReqDtos?.[index]?.link
                                            ? "border border-[#B91C1C]"
                                            : "border border-gray-300"
                                        }`}
                                        style={{
                                          outline: errors?.eventReqDtos?.[index]
                                            ?.link
                                            ? "2px solid red"
                                            : "none",
                                        }}
                                      />
                                       {errors?.eventReqDtos?.[index]?.link && (
    <p className="text-[#B91C1C] text-sm mt-1">
      {errors?.eventReqDtos[index]?.link?.message}
    </p>
  )}
                                    </div>
                                  </div>


</div>
<div className='grid grid-cols-2 gap-7'>
<div className="form-group">
    <label
        htmlFor="username"
        className="block text-[#374151] font-semibold text-sm font-sans"
    >
        Email
    </label>
    <div className="input-group mb-3 mt-2">
        <input
          {...register(
            `eventReqDtos.${index}.contactPersonEmail`
          )}
            type="email"
            placeholder="Enter your Email"

            className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
        />
        
    </div>
</div>
<div className=" form-group mb-4 sm:mb-0">
<label
        htmlFor="username"
        className="block text-[#374151] font-semibold text-sm font-sans"
    >
        Phone Number
    </label>
                  <div className="flex border border-gray-300 rounded mt-1 form-controls">
                    <select
                     {...register(
                      `eventReqDtos.${index}.phoneisoCode`
                    )}
                    onInput={(e) => {
                      e.currentTarget.value = e.currentTarget.value.replace(/[^0-9]/g, "");
                    }}
                       value={watch(`eventReqDtos.${index}.phoneisoCode`) || phoneCode.isoCode || ""}
                      onChange={(e) => phoneNuberChanges(e,index)}
                      className="border-none bg-white pl-3 py-2 text-sm font-semibold text-gray-700 focus:outline-none"
                    >
                      {mtContryData.map((item: any) => (
                        <option key={item.id} value={item.isoCode || ""}>
                          {item.isoCode}
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      placeholder="Enter your phone number"
                      {...register(
                        `eventReqDtos.${index}.phoneNo`
                      )}
                    
                      className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                    />
                  </div>
                </div>
</div>
<div className='grid grid-cols-2 gap-7'>
<div className="form-group mb-4">
                                  <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                    Event Type
                                  </label>
                                  <div className="relative">
                                    <select
                                      {...register(
                                        `eventReqDtos.${index}.type`
                                      )}
                                      className={`form-control p-2 rounded mt-1 w-full text-[#6B7280] ${
                                        errors?.eventReqDtos?.[index]?.type
                                          ? "border-[#B91C1C] border-2"
                                          : "border-gray-300 border"
                                      }`}
                                    >
                                      <option value="">Select Event Type</option>
                                      <option value="VIRTUAL">Remote</option>
                                      <option value="VENUE">Venue</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="form-group mb-4">
                                  <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                    Event Country
                                  </label>
                                  <div className="relative">
                                    <select
                                     value={
                                      selectedContry
                                        ? selectedContry:submittedData?.eventRespDtos?.[index]
                                            ?.mtCountryDto?.id
                                    }
                                    {...register(
                                      `eventReqDtos.${index}.mtCountryDto`
                                    )}
                                      onChange={(e) => handleCountryChanges(e,index)}
                                      className={`form-control border p-2 rounded mt-1 w-full custom-dropdown`}
                                    >
                                      <option value="">Select country</option>
                                      {mtContryData.map((item: any) => (
                                        <option
                                          key={item.id}
                                          value={
                                            item.id !== null ? item.id : ""
                                          }
                                        >
                                          {item.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
</div>
                                {eventType ==='VENUE' &&
<div className="form-group mb-4">
                                  <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                    Event Venue
                                  </label>
                                  <div className="relative">
                                    <input
                                      type="text"
                                      placeholder="Enter Event Venue "
                                      {...register(
                                        `eventReqDtos.${index}.venue`
                                      )}
                                      className={`form-control mt-1 p-2 rounded w-full font-medium ${
                                        errors?.eventReqDtos?.[index]?.venue
                                          ? "border border-[#B91C1C]"
                                          : "border border-gray-300"
                                      }`}
                                      style={{
                                        outline: errors?.eventReqDtos?.[index]
                                          ?.venue
                                          ? "2px solid red"
                                          : "none",
                                      }}
                                    />
                                  </div>
                                </div>}
                                 
                                </Typography>
                              </AccordionDetails>
                            </Accordion>
                          </div>
  
                          {/* </> */}
                        </div>
                    )})}
          {events.length <= 0 && (
          <div
            onClick={handleAddEvent}
            className="mt-4 p-2 w-[12rem] h-10 cursor-pointer bg-[#FFFFFF] text-gray-700 font-semibold rounded border border-gray-300"
          >
            {events?.length === 0 ? "+ Add Event Details" : "+ Add another Event"}
          </div>
        )}
         
        </div>
        </div>
    <div className="px-4 flex justify-end  p-4 items-center  bg-white"
              style={{
                boxShadow: "0px -16px 50px 0px #0000000D",
              }}>
                 <div></div>
        <div>
         
          <button
            type="submit"
            className="px-7 py-2 gradient-background font-Inter text-white rounded font-bold text-base"
            
          >
            Update
          </button>
        </div>
      </div>
    </form>
    {showConfirmation &&
  <DynamicTextPopup onClose={handleClosePopup} title='  Confirm Profile Update' body='You are about to update  profile information. Please review the changes before saving. This action will overwrite the existing details.' confirmButtonName='Confirm' closeButtonName='Cancel'
  onConfirm={saveData} />
}
        </div>
      
  )
}

export default EditEvent
